(function() {
  var StepHandler,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  StepHandler = App.loadClass('grower::handlers/placement/StepHandler');

  exports.FieldSelectionHandler = (function(superClass) {
    extend(FieldSelectionHandler, superClass);

    function FieldSelectionHandler() {
      this._numSelectedFields = bind(this._numSelectedFields, this);
      this._updateSelectAllButton = bind(this._updateSelectAllButton, this);
      this.afterLoadLayout = bind(this.afterLoadLayout, this);
      this.setFieldAspect = bind(this.setFieldAspect, this);
      this.getFieldAspect = bind(this.getFieldAspect, this);
      this.addValidationRules = bind(this.addValidationRules, this);
      return FieldSelectionHandler.__super__.constructor.apply(this, arguments);
    }

    FieldSelectionHandler.prototype.inputSel = 'button.spp-checkbox';

    FieldSelectionHandler.prototype.addValidationRules = function() {
      this.validator.registerRule({
        selector: '.validate-checkbox',
        text: 'Please select one or more fields',
        func: (function(_this) {
          return function(elem) {
            return !!_this.getInputEl().filter('.active').length;
          };
        })(this)
      });
      return $('.validationContainer').undelegate('.validate-checkbox', 'change');
    };

    FieldSelectionHandler.prototype.getFieldAspect = function(fieldID, aspectID) {
      return this.getInputEl({
        field: fieldID
      }).is(':enabled.active');
    };

    FieldSelectionHandler.prototype.setFieldAspect = function(fieldAspect) {
      var input;
      input = this.getInputEl({
        field: fieldAspect.id
      });
      if (fieldAspect.selected && input.is(':enabled')) {
        return input.addClass('active');
      } else {
        return input.removeClass('active');
      }
    };

    FieldSelectionHandler.prototype.afterLoadLayout = function(sel, data) {
      var num_fields, selectAll, step;
      FieldSelectionHandler.__super__.afterLoadLayout.call(this, sel, data);
      num_fields = this.taffyObjects.fields({
        disabled: {
          '!is': true
        }
      }).count();
      this.max_fields = num_fields < 50 ? num_fields : 50;
      this.layoutSelector.find('.fields-link').on('click', function() {
        return $('#nav_primary_links a').eq(0).trigger('click');
      });
      step = this;
      this.getInputEl().on('click', function(e) {
        var el;
        el = $(this);
        if (el.is(':not(.active)') && step._numSelectedFields() >= step.max_fields) {
          e.stopImmediatePropagation();
          step.msg.message_writer('error', 'You may not select more than 50 fields at once.');
          return;
        }
        step.msg.message_writer('clear');
        return setTimeout(function() {
          el.change();
          return step._updateSelectAllButton();
        });
      });
      selectAll = $(this.parent.layoutSelector).find('#select_all_button');
      selectAll.on('click', (function(_this) {
        return function() {
          if (selectAll.hasClass('active')) {
            _this.getInputEl().filter('.active').click();
          } else {
            _this.taffyObjects.fields({
              disabled: {
                '!is': true
              }
            }).limit(_this.max_fields).each(function(field) {
              var el;
              el = _this.getInputEl({
                field: field.id
              });
              if (!el.is('.active')) {
                return el.addClass('active').change();
              }
            });
            _this.taffyObjects.fields({
              disabled: {
                '!is': true
              }
            }).start(_this.max_fields + 1).each(function(field) {
              var el;
              el = _this.getInputEl({
                field: field.id
              });
              if (el.is('.active')) {
                return el.removeClass('active').change();
              }
            });
          }
          return _this._updateSelectAllButton();
        };
      })(this));
      this._updateSelectAllButton();
      if (this.taffyObjects.fields().get().length === 0) {
        return $(this.parent.layoutSelector).find('#next_button').prop('disabled', true);
      }
    };

    FieldSelectionHandler.prototype._updateSelectAllButton = function() {
      var selectAll;
      selectAll = $(this.parent.layoutSelector).find('#select_all_button');
      if (this._numSelectedFields() >= this.max_fields) {
        return selectAll.text('Deselect All').addClass('active');
      } else {
        return selectAll.text('Select All').removeClass('active');
      }
    };

    FieldSelectionHandler.prototype._numSelectedFields = function() {
      return this.getInputEl().filter('.active').length;
    };

    return FieldSelectionHandler;

  })(StepHandler);

}).call(this);
